import { log } from 'log';
import { addParamsToUrl } from '@theme/js/utils/url.util';

export { areSourcesEqual } from '@core/js/components/common/Image/helpers';

export const addAllowedParamsToSrc = (src: string): string => {
    try {
        if (src.includes('base64')) {
            return src;
        }

        const search = new URLSearchParams(location.search);
        const casinoname = search.get('casinoname');
        const site = search.get('site');
        const allowedParams = {
            ...casinoname && { casinoname },
            ...site && { site }
        };

        return addParamsToUrl(allowedParams, src);
    } catch (error) {
        log('error', error);

        return '';
    }
};
